export const staticData = {
  linkType: {
    external: 'external',
    post: 'post',
    product: 'product',
    innerExternal: 'innerExternal',
  },
  proFeatureType: {
    shop: 'shop',
    gallery: 'gallery',
    resume: 'resume',
  },
  planType: {
    basic: 'basic',
    pro: 'pro',
  },
  planSubscriptionType: {
    new: 'new',
    renew: 'renew',
  },
  resumeItemType: {
    education: 'education',
    experience: 'experience',
    skill: 'skill',
    achievement: 'achievement',
    external: 'external',
    post: 'post',
  },
  categoryType: {
    product: 'product',
    post: 'post',
  },
  adType: {
    plan: 'plan',
    external: 'external',
  },
  orderStatus: {
    new: 'new',
    done: 'done',
    cancel: 'cancel',
    packaging: 'packaging',
    delivery: 'delivery',
  },
  orderItemStatus: {
    none: 'none',
    done: 'done',
  },
  previewTabsObject: {
    profile: 'profile',
    links: 'links',
    shop: 'shop',
    gallery: 'gallery',
    resume: 'resume',
  },
  previewTabs: ['profile', 'links', 'shop', 'gallery', 'resume'],
  previewTabsRoutes: {
    profile: 'PreviewProfile',
    links: 'PreviewLink',
    shop: 'PreviewShop',
    gallery: 'PreviewGallery',
    resume: 'PreviewResume',
  },
  logoList: [
    'web',
    'red-link',
    'link-variant',
    'email-outline',
    'instagram',
    'twitter1',
    'twitter',
    'telegram1',
    'telegram',
    'whatsapp',
    'linkedin',
    'facebook1',
    'facebook',
    'dribbble',
    'behance',
    'skype',
    'virgool',
    'aparat',
    'wisgoon',
    'atbox',
    'nazdika',
    'gap',
    'igap',
    'bale',
    'anchor',
    'amazon',
    'deezer',
    'pandora',
    'tidal',
    'youtube-music',
    'apple-music',
    'apple-podcast',
    'castbox',
    'google-podcast',
    'shenoto',
    '9gag',
    'academia-edu',
    'airbnb',
    'angelist',
    'lastfm',
    'badoo',
    'blackberry',
    'blogger',
    'busuu',
    'codepen',
    'coderwall',
    'delicious',
    'devianart',
    'digg',
    'discord',
    'dislike',
    'disqus',
    'dropbox',
    'envato',
    'evernote',
    'messenger',
    'flickr',
    'forrst',
    'foursquare',
    'gab',
    'git',
    'github1',
    'github',
    'gofundme',
    'goodreads',
    'google-allo',
    'google-drive',
    'google-hangouts',
    'google-hangouts1',
    'google-photos',
    'google-play',
    'google-plus',
    'google-plus1',
    'houzz',
    'kakao-talk',
    'kickstarter',
    'kik',
    'klout',
    'lastfm1',
    'like',
    'line',
    'medium1',
    'medium',
    'meetme',
    'meetup',
    'myspace',
    'odnoklassniki',
    'open-source',
    'path',
    'patreon',
    'periscope',
    'photobucket',
    'picasa',
    'pinboard',
    'pinterest',
    'pixabay',
    'plurk1',
    'plurk',
    'product-hunt',
    'quora',
    'reddit',
    'revebnation',
    'rss',
    'sina-weibo',
    'skillshare',
    'slack',
    'slack1',
    'snapchat',
    'soundcloud',
    'spotify',
    'stack-overflow',
    'steam',
    'stumbleupon',
    'swarm',
    'tagged',
    'team-viewer',
    'tinder',
    'trello',
    'tumblr',
    'twitch',
    'twoo',
    'uber',
    'unspash',
    'v-live',
    'viber',
    'viddler',
    'vimeo',
    'vine',
    'VK',
    'wattpad',
    'waze',
    'wechat',
    'wordpress',
    'xanga',
    'xing',
    'yahoo1',
    'yahoo',
    'yelp',
    'youtube',
    'zootool',
    'at',
    'camera',
    'cellphone-iphone',
    'image-multiple',
    'phone',
  ],
  shopContactTemplates: [
    {
      title: 'shopContactAddresses',
      items: [
        {
          title: 'address',
          prefix: '',
          logoName: 'periscope',
          withPostfix: false,
        },
      ],
    },
    {
      title: 'shopContactPhones',
      items: [
        {
          title: 'telphone',
          prefix: 'tel:',
          logoName: 'phone',
          withPostfix: false,
        },
        {
          title: 'cellphone',
          prefix: 'tel:',
          logoName: 'cellphone-iphone',
          withPostfix: false,
        },
        {
          title: 'email',
          prefix: 'mailto:',
          logoName: 'email-outline',
          withPostfix: false,
        },
      ],
    },
    {
      title: 'shopContactMessengers',
      items: [
        {
          title: 'telegram',
          prefix: 'https://www.telegram.me/',
          logoName: 'telegram',
          withPostfix: true,
        },
        {
          title: 'whatsapp',
          prefix: 'https://wa.me/',
          logoName: 'whatsapp',
          withPostfix: true,
        },
      ],
    },
  ],
  linkTemplates: [
    {
      title: 'socialMedia',
      items: [
        {
          title: 'Instagram',
          prefix: 'https://www.instagram.com/',
          logoName: 'instagram',
          asThumbnail: true,
          withPostfix: true,
        },
        {
          title: 'Facebook',
          prefix: 'https://www.facebook.com/',
          logoName: 'facebook',
          asThumbnail: true,
          withPostfix: true,
        },
        {
          title: 'Twitter',
          prefix: 'https://www.twitter.com/',
          logoName: 'twitter',
          asThumbnail: false,
          withPostfix: true,
        },
        {
          title: 'Youtube',
          prefix: 'https://www.youtube.com/',
          logoName: 'youtube',
          asThumbnail: false,
          withPostfix: true,
        },
        // {
        //   title: 'ClubHouse',
        //   prefix: 'https://www.clubhouse.com/',
        //   logoName: 'clubhouse',
        //   asThumbnail: false,
        //  withPostfix: true,
        // },
        {
          title: 'Linkedin',
          prefix: 'https://www.linkedin.com/',
          logoName: 'linkedin',
          asThumbnail: false,
          withPostfix: true,
        },
        {
          title: 'Pinterest',
          prefix: 'https://www.pinterest.com/',
          logoName: 'pinterest',
          asThumbnail: false,
          withPostfix: true,
        },
        {
          title: 'Dribbble',
          prefix: 'https://www.dribbble.com/',
          logoName: 'dribbble',
          asThumbnail: true,
          withPostfix: true,
        },
        {
          title: 'Behance',
          prefix: 'https://www.behance.net/',
          logoName: 'behance',
          asThumbnail: false,
          withPostfix: true,
        },
        {
          title: 'Medium',
          prefix: 'https://www.medium.com/',
          logoName: 'medium',
          asThumbnail: false,
          withPostfix: true,
        },
        {
          title: 'Twitch',
          prefix: 'https://www.twitch.tv/',
          logoName: 'twitch',
          asThumbnail: false,
          withPostfix: true,
        },
        {
          title: 'Discord',
          prefix: 'https://www.discord.com/',
          logoName: 'discord',
          asThumbnail: false,
          withPostfix: true,
        },
        {
          title: 'Github',
          prefix: 'https://www.github.com/',
          logoName: 'github',
          asThumbnail: false,
          withPostfix: true,
        },
        // {
        //   title: 'Gitlab',
        //   prefix: 'https://www.gitlab.com/',
        //   logoName: 'gitlab',
        //   asThumbnail: false,
        //  withPostfix: true,
        // },
        {
          title: 'Stackoverflow',
          prefix: 'https://www.stackoverflow.com/',
          logoName: 'stack-overflow',
          asThumbnail: false,
          withPostfix: true,
        },
        {
          title: 'Aparat',
          prefix: 'https://www.aparat.com/',
          logoName: 'aparat',
          asThumbnail: false,
          withPostfix: true,
        },
        {
          title: 'Virgool',
          prefix: 'https://www.virgool.io/',
          logoName: 'virgool',
          asThumbnail: false,
          withPostfix: true,
        },
      ],
    },
    {
      title: 'podcasts',
      items: [
        {
          title: 'Spotify',
          prefix: 'https://www.spotify.com/',
          logoName: 'spotify',
          asThumbnail: true,
          withPostfix: true,
        },
        {
          title: 'Anchor',
          prefix: 'https://www.anchor.fm/',
          logoName: 'anchor',
          asThumbnail: false,
          withPostfix: true,
        },
        {
          title: 'Sound Cloud',
          prefix: 'https://www.soundcloud.com/',
          logoName: 'soundcloud',
          asThumbnail: true,
          withPostfix: true,
        },
        {
          title: 'Castbox',
          prefix: 'https://www.castbox.fm/',
          logoName: 'castbox',
          asThumbnail: true,
          withPostfix: true,
        },
        {
          title: 'Apple Podcasts',
          prefix: 'https://www.apple.com/apple-podcasts/',
          logoName: 'apple-podcast',
          asThumbnail: false,
          withPostfix: true,
        },
        {
          title: 'Google Podcasts',
          prefix: 'https://podcasts.google.com/',
          logoName: 'google-podcast',
          asThumbnail: false,
          withPostfix: true,
        },
        // {
        //   title: 'Audible',
        //   prefix: 'https://www.audible.com/',
        //   logoName: 'audible',
        //   asThumbnail: false,
        //  withPostfix: true,
        // },
        // {
        //   title: 'Stitcher',
        //   prefix: 'https://www.stitcher.com/',
        //   logoName: 'stitcher',
        //   asThumbnail: false,
        //  withPostfix: true,
        // },
        // {
        //   title: 'Tunein',
        //   prefix: 'https://www.tunein.com/',
        //   logoName: 'tunein',
        //   asThumbnail: false,
        //  withPostfix: true,
        // },
        {
          title: 'Lastfm',
          prefix: 'https://www.last.fm/',
          logoName: 'lastfm',
          asThumbnail: false,
          withPostfix: true,
        },
        {
          title: 'Shenoto',
          prefix: 'https://www.shenoto.com/',
          logoName: 'shenoto',
          asThumbnail: false,
          withPostfix: true,
        },
      ],
    },
    {
      title: 'messengers',
      items: [
        {
          title: 'Telegram',
          prefix: 'https://www.telegram.me/',
          logoName: 'telegram',
          asThumbnail: true,
          withPostfix: true,
        },
        {
          title: 'Whatsapp',
          prefix: 'https://wa.me/',
          logoName: 'whatsapp',
          asThumbnail: true,
          withPostfix: true,
        },
        {
          title: 'Snapchat',
          prefix: 'https://www.snapchat.com/',
          logoName: 'snapchat',
          asThumbnail: true,
          withPostfix: true,
        },
        {
          title: 'Skype',
          prefix: 'https://www.skype.com/',
          logoName: 'skype',
          asThumbnail: false,
          withPostfix: true,
        },
        {
          title: 'Viber',
          prefix: 'https://www.viber.com/',
          logoName: 'viber',
          asThumbnail: false,
          withPostfix: true,
        },
      ],
    },
    {
      title: 'contactWays',
      items: [
        {
          title: 'Email',
          prefix: 'mailto:',
          logoName: 'email-outline',
          asThumbnail: true,
          withPostfix: false,
        },
        {
          title: 'Telephone',
          prefix: 'tel:',
          logoName: 'phone',
          asThumbnail: true,
          withPostfix: false,
        },
        {
          title: 'Cellphone',
          prefix: 'tel:',
          logoName: 'cellphone-iphone',
          asThumbnail: true,
          withPostfix: false,
        },
      ],
    },
  ],
};
